import { Order } from '__generated__/graphql';
import {
  SEARCH_ORDER_BY_EMAIL_PHONE_QUERY,
  SEARCH_ORDER_BY_EMAIL_QUERY,
  SEARCH_ORDER_BY_EMAIL_POSTCODE_QUERY,
  SEARCH_ORDER_BY_PHONE_QUERY,
} from 'gql/queries/order';

export type OrderSearchQueriesUnion =
  | typeof SEARCH_ORDER_BY_PHONE_QUERY
  | typeof SEARCH_ORDER_BY_EMAIL_QUERY
  | typeof SEARCH_ORDER_BY_EMAIL_POSTCODE_QUERY
  | typeof SEARCH_ORDER_BY_EMAIL_PHONE_QUERY;

export type SearchOrderbyPhoneResult = {
  searchOrderByPhone: Order;
};

export type SearchOrderByEmailPhoneResult = {
  searchOrderByEmailPhone: Order;
};

export type SearchOrderByEmailResult = {
  searchOrderByEmail: Order;
};

export type SearchOrderByEmailPostcodeResult = {
  searchOrderByEmailPostcode: Order;
};

export type OrderSearchQueryResultUnion =
  | SearchOrderbyPhoneResult
  | SearchOrderByEmailPhoneResult
  | SearchOrderByEmailResult
  | SearchOrderByEmailPostcodeResult;

export enum OrderSearchOperationName {
  SearchOrderByEmail = 'SearchOrderByEmail',
  SearchOrderByEmailPhone = 'SearchOrderByEmailPhone',
  SearchOrderByEmailPostcode = 'SearchOrderByEmailPostcode',
  SearchOrderByPhone = 'SearchOrderByPhone',
}

export type OrderByEmailPhoneFormsFields = {
  email: string;
  orderNo: string;
  phone: string;
};

export type OrderByPhoneFormFields = {
  orderNo: string;
  phone: string;
};

export type OrderByPostcodeEmailFormFields = {
  orderNo: string;
  postcode: string;
  email: string;
};

export type OrderByEmailFormFields = {
  orderNo: string;
  email: string;
};

export type formFieldUnion =
  | OrderByEmailPhoneFormsFields
  | OrderByPhoneFormFields
  | OrderByEmailFormFields
  | OrderByPostcodeEmailFormFields;
